<div fxLayout="row" class="images">
  <img src="{{ happy1$ | async }}" />
  <img src="{{ happy2$ | async }}" />
  <h1 *ngIf="!loading" fxLayout="row" fxLayoutAlign="center center">
    <span ngClass.gt-xs="enlarged" class="title-text"
      >Join the excitement!</span
    >
  </h1>
</div>
